import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

export const commonHeading = css`
  ${theme.responsiveText.HEADING.XS};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      ${theme.responsiveText.HEADING.SM};
    `,
  )};
`;
